export default "__VITE_ASSET__d6f7751a__"